<script lang="ts" module>
	import type { Snippet } from 'svelte';
	import type { ClassValue, SvelteHTMLElements } from 'svelte/elements';
	import type { VariantProps } from 'tailwind-variants';
	import { tv } from '../tv';
	import { CONTAINER_COLOR_VARIANTS, RADII_VARIANTS } from '../variants';

	export const iconButtonVariants = tv({
		base: 'inline-flex w-auto cursor-pointer items-center justify-center text-(--v-on-container) no-underline hover:bg-(--v-container-hover) focus-visible:bg-(--v-container-hover) active:bg-(--v-container-active) aria-pressed:bg-(--v-container-active) aria-pressed:hover:bg-(--v-container-hover) aria-pressed:focus-visible:bg-(--v-container-hover) aria-pressed:active:bg-(--v-container-active) leading-none focus-outline disabled-state',
		variants: {
			size: { '600': 'p-s400', '500': 'p-s300', '400': 'p-s200', '300': 'p-s100' },
			variant: CONTAINER_COLOR_VARIANTS,
			fill: { Soft: 'bg-(--v-container)', None: 'bg-transparent' },
			outlined: {
				true: '[box-shadow:inset_0_0_0_var(--border-width-b400)_var(--v-container-line)]'
			},
			radii: RADII_VARIANTS
		},
		defaultVariants: { size: '400', variant: 'Surface', fill: 'Soft', radii: '400' }
	});

	export type IconButtonProps<T extends keyof SvelteHTMLElements = 'button'> = Omit<
		SvelteHTMLElements[T],
		'class'
	> &
		VariantProps<typeof iconButtonVariants> & {
			as?: T;
			children?: Snippet;
			class?: ClassValue;
			ref?: HTMLElement | null;
		};
</script>

<script lang="ts" generics="T extends keyof SvelteHTMLElements = 'button'">
	let {
		as = 'button' as T,
		children,
		class: className,
		fill,
		outlined,
		radii,
		ref = $bindable(null),
		size,
		variant,
		...rest
	}: IconButtonProps<T> = $props();
</script>

<svelte:element
	this={as}
	bind:this={ref}
	class={[iconButtonVariants({ fill, outlined, radii, size, variant }), className]}
	{...rest}
>
	{@render children?.()}
</svelte:element>
